import complexArbitrator from './complexArbitrator';
import { SmartPillArbitrator } from 'owa-smart-pill';

/**
 * Creates different smart pill arbitrator based on the flight setting
 */
export default function createSmartPillArbitrator(): SmartPillArbitrator {
    return complexArbitrator;
}
